module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Review Sort Info"}}')
  delete Component.options._Ctor
}
